/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { IRadiologyStudy } from 'app/shared/model/radiology-study.model';
import { MemberRole } from 'app/shared/model/enumerations/member-role.model';
import { LabServiceType } from 'app/shared/model/enumerations/lab-service-type.model';

export interface IIntraOPInvestigation {
  id?: string;
  orderedBy?: keyof typeof MemberRole | null;
  orderedById?: string | null;
  serviceType?: keyof typeof LabServiceType | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  surgery?: IPatientProcedure;
  labPrescription?: ILabPrescription | null;
  radiologyStudy?: IRadiologyStudy | null;
}

export const defaultValue: Readonly<IIntraOPInvestigation> = {
  active: false,
};
